import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { PlusIcon, SearchIcon, FilterIcon, LayoutTemplateIcon, ClockIcon, WalletIcon, MoreHorizontalIcon, CheckCircle2Icon } from 'lucide-react';
import { CAMPAIGN_TEMPLATES } from '../../data/brandMockData';
import { CreateTemplateModal } from '../../components/brand/CreateTemplateModal';
export function CampaignTemplates() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [isCreateTemplateOpen, setIsCreateTemplateOpen] = useState(false);
  const categories = ['All', 'Vehicle Launch', 'Seasonal', 'Service', 'Exchange', 'Brand Awareness'];
  const filteredTemplates = selectedCategory === 'All' ? CAMPAIGN_TEMPLATES : CAMPAIGN_TEMPLATES.filter(t => t.category === selectedCategory);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1916">
      <Sidebar data-id="element-1917" />
      <main className="flex-1 overflow-y-auto" data-id="element-1918">
        <Header data-id="element-1919" />
        <div className="px-8 py-8" data-id="element-1920">
          <div className="flex items-center justify-between mb-8" data-id="element-1921">
            <div data-id="element-1922">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1923">
                Campaign Templates
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-1924">
                Manage and distribute campaign templates to partner network
              </p>
            </div>
            <button onClick={() => setIsCreateTemplateOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 shadow-sm" data-id="element-1925">
              <PlusIcon size={16} data-id="element-1926" />
              Create Template
            </button>
          </div>

          {/* Filters */}
          <div className="flex items-center gap-4 mb-8 overflow-x-auto pb-2" data-id="element-1927">
            {categories.map(category => <button key={category} onClick={() => setSelectedCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${selectedCategory === category ? 'bg-blue-600 text-white shadow-sm' : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`} data-id="element-1928">
                {category}
              </button>)}
          </div>

          {/* Templates Grid */}
          <div className="grid grid-cols-3 gap-6" data-id="element-1929">
            {filteredTemplates.map(template => <div key={template.id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow group" data-id="element-1930">
                <div className="relative h-48 bg-gray-100 overflow-hidden" data-id="element-1931">
                  <img src={template.thumbnail} alt={template.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1932" />
                  <div className="absolute top-3 right-3" data-id="element-1933">
                    <button className="p-1.5 bg-white/90 backdrop-blur-sm rounded-full text-gray-600 hover:text-gray-900 shadow-sm" data-id="element-1934">
                      <MoreHorizontalIcon size={16} data-id="element-1935" />
                    </button>
                  </div>
                  <div className="absolute bottom-3 left-3" data-id="element-1936">
                    <span className="px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium rounded-full" data-id="element-1937">
                      {template.category}
                    </span>
                  </div>
                </div>

                <div className="p-5" data-id="element-1938">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1939">
                    {template.name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-4 line-clamp-2" data-id="element-1940">
                    {template.description}
                  </p>

                  <div className="space-y-3 mb-5" data-id="element-1941">
                    <div className="flex items-center text-sm text-gray-600" data-id="element-1942">
                      <LayoutTemplateIcon size={16} className="mr-2 text-gray-400" data-id="element-1943" />
                      <span className="mr-2" data-id="element-1944">Channels:</span>
                      <div className="flex gap-1" data-id="element-1945">
                        {template.channels.map(channel => <span key={channel} className="px-1.5 py-0.5 bg-gray-100 rounded text-xs font-medium text-gray-600" data-id="element-1946">
                            {channel}
                          </span>)}
                      </div>
                    </div>
                    <div className="flex items-center text-sm text-gray-600" data-id="element-1947">
                      <ClockIcon size={16} className="mr-2 text-gray-400" data-id="element-1948" />
                      <span data-id="element-1949">Duration: {template.duration}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600" data-id="element-1950">
                      <WalletIcon size={16} className="mr-2 text-gray-400" data-id="element-1951" />
                      <span data-id="element-1952">Budget: {template.budgetRange}</span>
                    </div>
                  </div>

                  <div className="flex gap-3" data-id="element-1953">
                    <button className="flex-1 py-2 bg-blue-50 text-blue-600 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors" data-id="element-1954">
                      Preview
                    </button>
                    <button className="flex-1 py-2 bg-white border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-1955">
                      Edit
                    </button>
                  </div>
                </div>
              </div>)}

            {/* Add New Card Placeholder */}
            <button onClick={() => setIsCreateTemplateOpen(true)} className="border-2 border-dashed border-gray-300 rounded-xl p-8 flex flex-col items-center justify-center text-gray-400 hover:border-blue-400 hover:text-blue-500 hover:bg-blue-50/50 transition-all h-full min-h-[400px]" data-id="element-1956">
              <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors" data-id="element-1957">
                <PlusIcon size={32} data-id="element-1958" />
              </div>
              <span className="text-lg font-medium" data-id="element-1959">Create New Template</span>
              <span className="text-sm mt-2 text-center max-w-[200px]" data-id="element-1960">
                Start from scratch or duplicate an existing template
              </span>
            </button>
          </div>
        </div>
      </main>

      <CreateTemplateModal isOpen={isCreateTemplateOpen} onClose={() => setIsCreateTemplateOpen(false)} data-id="element-1961" />
    </div>;
}